import { Image, Input } from '@heroui/react';
import { FC } from 'react';
import ReactCountryFlag from 'react-country-flag';
import { useForm } from 'react-hook-form';
import { Flex, inputProps } from 'src/components';
import { countryFlagHelper } from 'src/config';
import { LanguageDataDocumentRequest, LanguageDataResponse } from 'src/types';

import { LanguageFormEntity, LanguageFormOptions } from './util';

interface LanguageFormProps {
    onSubmit: (data: LanguageDataDocumentRequest) => void;
    initialValues?: LanguageDataResponse;
    formId?: string;
}

export const CreateLanguageForm: FC<LanguageFormProps> = ({
  onSubmit,
  initialValues,
  formId,
}) => {
  const {
    formState,
    register,
    watch,
    handleSubmit,
  } = useForm<LanguageFormEntity>({
    ...LanguageFormOptions,
    defaultValues: {
      name: initialValues?.name || '',
      code: initialValues?.code || '',
    },
  });
  const flag = countryFlagHelper(watch('code'));

  return (
    <form
      data-testid={formId}
      noValidate
      id={formId}
      onSubmit={handleSubmit(onSubmit)}
    >
      <Flex direction="column" gap="20px" itemAlign="flex-start">
        {flag.value && flag.type === 'iso' ? (
          <ReactCountryFlag
            countryCode={watch('code')}
            svg
            style={{ width: 30, height: 30 }}
          />
        ) : (
          <Image
            classNames={{ wrapper: 'mr-2 inline-block' }}
            radius="none"
            src={flag?.value}
            alt={flag?.value}
            width={30}
            height={30}
          />
        )}
        <Input
          {...inputProps}
          {...register('name')}
          placeholder="Enter language name"
          type="text"
          label="Name"
          isInvalid={!!formState.errors.name?.message}
          errorMessage={formState.errors.name?.message}
        />
        <Input
          {...inputProps}
          {...register('code')}
          placeholder="Enter language code"
          type="text"
          label="Code"
          isInvalid={!!formState.errors.code?.message}
          errorMessage={formState.errors.code?.message}
        />
      </Flex>
    </form>
  );
};
